
import CryptoJS from 'crypto-js'
import {EnmoliParamter,EnmoliSubmiter} from '../utils/jquery.valid'
import {
  isLocal
} from '../config/env'
const _gf_constants1 = "showaj";
const _gf_constants2 = "1000ax";
const _gf_constants3 = "showData";
export const XSH5Utils = {
    getRequestValidConfigString : function () {
      const enmoliParamter = new EnmoliParamter();
      return enmoliParamter.ayz("showself_h5_XSH5Utils", "showselfAnchorVisitorParameters");
    },

    convertSecondToHourAndMinutes:function(sencond){
      var returnTime="";
      if (null == sencond || ""==sencond) {
        return "0";
      }
      var s = parseInt(sencond);
      var N =parseInt( s / 3600);
      if (N > 0){
        returnTime+=N + "小时";
      }
      s = s % 3600;
      var K = parseInt(s / 60);
      if (K >= 0){
        if(K==0){
          returnTime+="1分钟";
        }else{
          returnTime+=K + "分钟";
        }
      }
      returnTime+="前";

      return returnTime;
    },
    encryptByDES: function (message, key) {
      if (!key) {
        key = this.getRequestValidConfigString();
      }
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },

    decryptByDES: function (ciphertext, key) {
      if (!key) {
        key = this.getRequestValidConfigString();
      }
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      // direct decrypt ciphertext
      var decrypted = CryptoJS.DES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
      }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    },

    decryptResponse : function (ciphertext) {
      return this.decryptByDES(ciphertext, rk);
    },

    isMobile : function() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return true;
      } else {
        return false;
      }
    },

    getRandomStr : function() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x7|0x8)).toString(16);
      });
      return uuid;
    },

    getQueryParameter : function(key) {
      var s = window.location.href.split("?")[1];
      if (!!s) {
        var params = s.split("&");
        for (index in params) {
          var param =  params[index].split("=");
          if (param[0].toLowerCase() == key.toLowerCase()) {
            return param[1];
          }
        }
      }
    },
    /**
     * mobile phone number check
     *
     * return false: check fail; true check pass
     */
    funcPhoneNumCheck : function(phoneNum){
      if(!phoneNum){
        return false;
      }
      var telReg = phoneNum.match(/^(0|86|17951)?(1[0-9])[0-9]{9}$/);
      if (telReg == null) {
        return false;
      }
      return true;
    },

    /**
     * ID card No check
     * @param id
     * @returns {boolean}
     */
    funcIDcardNoCheck : function(id){
      if(!id){
        return false;
      }
      //15位数身份证正则表达式
      var arg1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      //18位数身份证正则表达式
      var arg2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Z])$/;
      if (id.match(arg1) == null && ((id.match(arg2)==null)||(id.toUpperCase().match(arg2)==null))) {
        return false;
      }
      return true;
    }
    ,
    funcRandomStr:function(len)
    {
      len = len || 32;
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
      var pwd = '';
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    funcIsChinese:function(chinese){
      if(!chinese){
        return false;
      }
      var nameMatch = chinese.match(/[\u4e00-\u9fa5]/g);
      if(!(nameMatch instanceof Array) || (chinese.length!=nameMatch.length)){
        return false;
      }
      return true;
    },
    setChannelId : function (id) {
      window.localStorage.c = id;
    },
    getChannelId : function () {
      if (!!window.localStorage.c && window.localStorage.c.length == 6) {
        return "40536100" + window.localStorage.c;
      } else {
        return window.localStorage.c;
      }
    },
    addTimestamp : function (url) {
      if (url.indexOf('?') >= 0) {
        url += '&_st1=' + new Date().getTime();
      } else {
        url += '?_st1=' + new Date().getTime();
      }
      return url;
    },
    replaceImageUrl:function (htm){
      var oldRole=/\/role\//g;
      var newRole="/role/web/";

      var oldLevel1=/\/level1\//g;
      var newLevel1="/level1/web/";

      var oldLevel=/\/level\//g;
      var newLevel="/level/web/";

      var oldGrade=/\/grade\//g;
      var newGrade="/grade/web/";

      var oldSvip=/\/svip\//g;
      var newSvip="/svip/web/";

      var oldStar=/\/star\/star_/g;        //star/star
      var newStar="/star/web/star_";
      if (htm!=undefined && htm!="") {
        htm = htm.replace(oldRole, newRole)
          .replace(oldLevel1, newLevel1)
          .replace(oldLevel, newLevel)
          .replace(oldGrade, newGrade)
          .replace(oldSvip, newSvip)
          .replace(oldStar, newStar);
      }
      return htm;
    },
    extend:function (destObj, srcObj) {
      jQuery.extend(destObj, srcObj);
    },
    isEmptyObject:function (obj) {
      return jQuery.isEmptyObject(obj); // true
    },
    //sign
    _cf:function(xsConfig) {
      if ((xsConfig.method == 'POST' || xsConfig.method == 'PUT' || xsConfig.method == 'DELETE' || xsConfig.method == 'GET')) {
        var enmoliSubmiter = new EnmoliSubmiter();
        var newOptions = {};
        var lastIndexOf = xsConfig.url.lastIndexOf("?");
        if (lastIndexOf > -1) {
          enmoliSubmiter.bnu(xsConfig.url.substr(lastIndexOf + 1), newOptions);
        }
        if (!!xsConfig.data) {
          enmoliSubmiter.bn(xsConfig.data, newOptions);
        } else {
          xsConfig.data = {};
        }
        var _a123 = eval("_gf" + "_constants" + 1);
        var _b2x = eval("_gf" + "_constants" + 2);
        var _c3y = eval("_gf" + "_constants" + 3);
        var aj = '_' + _a123.substring(4) + _b2x.substring(4) + _c3y.substring(4) + "1";
        //var aj = '_' + 'a' + 'ja' + 'x' + 'D' + 'a' + 'ta1';
        if (xsConfig.method == 'GET') {
          if (lastIndexOf > -1) {
            xsConfig.url = xsConfig.url + '&' + aj + "=" +  enmoliSubmiter.bsq(newOptions);
          }
        } else {
          xsConfig.data[aj] = enmoliSubmiter.bsq(newOptions);
        }
      }
    },

    getHttpConfig:function(method, url, success, error, data, ignoreToken) {

      var xsConfig = {};
      xsConfig.method = method;
      xsConfig.url = url;
      xsConfig.success = success;
      xsConfig.error = error;
      xsConfig.data = data;
      xsConfig.headers = {};
      xsConfig.dataType = "json";
      xsConfig.headers['Content-Type'] = "application/json;charset=UTF-8";
      if (!window.localStorage.web_did) {
        window.localStorage.web_did = this.getUUID();
      }
      xsConfig.headers['web_did'] = window.localStorage.web_did;

      if(!ignoreToken) {
        if(!!window.localStorage.hrtk) {
          if (xsConfig.url.indexOf('?') >= 0 ) {
            xsConfig.url += '&accessToken=' + window.localStorage.hrtk + '&is_h5=1';
          } else {
            xsConfig.url += '?accessToken=' + window.localStorage.hrtk + '&is_h5=1';
          }
        }
      }
      var channelId = XSH5Utils.getChannelId();
      if(!!channelId) {
        if (xsConfig.url.indexOf('?') >= 0 ) {
          xsConfig.url += '&c=' + channelId;
        } else {
          xsConfig.url += '?c=' + channelId;
        }
      }

      if(xsConfig.data != null){
        xsConfig.data["sessionid"] = window.localStorage.hrtk;
      }
      xsConfig.url = XSH5Utils.addTimestamp(xsConfig.url);
      this._cf(xsConfig);
      if(method=="POST"||method=="post"||method=="PUT"||method=="put"){
        xsConfig.data=JSON.stringify(xsConfig.data);
      }
      return xsConfig;
    },
    getUUID:function() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x7|0x8)).toString(16);
      });
      return uuid;
    },
    ajaxPost:function (url,data,success, error, ignoreToken) {
      var xsConfig = this.getHttpConfig("POST", url, success, error, data, ignoreToken);
      $.ajax(xsConfig);
    },
    ajaxGet:function(url, success, error, ignoreToken) {
      var xsConfig = this.getHttpConfig("GET", url, success, error, null, ignoreToken);
      $.ajax(xsConfig);
    }
};

export function funcFilterSpace(e){  //��¼ע����ֹ����ո�
    var keyCode;

    if(e.keyCode){
        keyCode = e.keyCode;
    }
    else if(e.which){
        keyCode = e.which;
    }
    else if(e.charCode){
        keyCode = e.charCode;
    }

    if(keyCode == 13 || keyCode == 32){
        return false;
    }
    return true;
}

export function funcToJSONString(object){
    var type = typeof object;
    if ('object' == type) {
        if (Array == object.constructor) type = 'array';
        else if (RegExp == object.constructor) type = 'regexp';
        else type = 'object';
    }
    switch (type) {
        case 'undefined':
        case 'unknown':
            return;
        case 'function':
        case 'boolean':
        case 'regexp':
            return object.toString();
        case 'number':
            return isFinite(object) ? object.toString() : 'null';

        case 'string':
            return '"' + object.replace(/(\\|\")/g, "\\$1").replace(/\n|\r|\t/g, function() {
                    var a = arguments[0];
                    return (a == '\n') ? '\\n': (a == '\r') ? '\\r': (a == '\t') ? '\\t': "";
                }) + '"';

        case 'object':
            if (object === null) return 'null';
            var results = [];
            for (var property in object) {
                var value = funcToJSONString(object[property]);
                if (value !== undefined) results.push(funcToJSONString(property) + ':' + value);
            }
            return '{' + results.join(',') + '}';
        case 'array':
            var results1 = [];
            for (var i = 0; i < object.length; i++) {
                var value1 = funcToJSONString(object[i]);
                if (value1 !== undefined) results1.push(value1);
            }
            return '[' + results1.join(',') + ']';
    }
}
export const v_mifeng_trim = {
  //去除字符串左空格
  ltrim : function(s) {
    return s.replace(/^(\s*| *)/,'');
  },
  //去除字符串右空格
  rtrim : function(s) {
    return s.replace(/(\s*| *)$/,'');
  },
  //去除字符串左右空格
  trim : function(text) {
    return text == null ?
      "" :
      ( text + "" ).replace( /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "" );
  },
  //去除字符串中所有空格
  trim_all : function(text) {
    text = text.replace(/^\s+/,'');
    for(var i = text.length-1; i>=0; i--)
    {
      if(/\S/.test(text.charAt(i)))
      {
        text = text.substring(0, i + 1);
        break;
      }
    }
    return text;
  }
};
//message type
export const gOb_msgType = {
  EM_MSG_TYPE_103_LEAVE_ROOM: 103,                //离开房间                    x
  EM_MSG_TYPE_104_ENTER_ROOM: 104,                //进入房间
  EM_MSG_TYPE_107_SEND_MESSAGE: 107,              //发送公聊、私聊消息
  EM_MSG_TYPE_110_FLY_SCREEN_MESSAGE: 110,        //飞屏消息
  EM_MSG_TYPE_111_DISPLAY_PRIVATE_MESSAGE: 111,   //用户私聊主播消息
  EM_MSG_TYPE_114_MOBILE_BOUND_MESSAGE: 114,      //用户手机绑定消息
  EM_MSG_TYPE_115_LIGHTEN_MESSAGE: 115,           //点亮消息                    x
  EM_MSG_TYPE_121_APP_AISSTANT_MESSAGE: 121,      //app附海报送礼消息
  EM_MSG_TYPE_201_BROADCAST_MESSAGE: 201,         //直播消息                    x
  EM_MSG_TYPE_202_VIEWER_LIST_UPDATE: 202,        //房间用户列表更新消息
  EM_MSG_TYPE_203_FORBID_CHAT_BEGIN_MESSAGE: 203, //禁言开始消息
  EM_MSG_TYPE_204_KICK_OUT_MESSAGE: 204,          //踢出消息
  EM_MSG_TYPE_205_SET_AS_ADMIN:205,               //提升为管理员
  EM_MSG_TYPE_206_CANNEL_ADMIN:206,               //取消管理员
  EM_MSG_TYPE_209_GIFT_DYNAMIC_LIST_UPDATE: 209,  //礼物动态列表更新消息
  EM_MSG_TYPE_213_FORBID_CHAT_END_MESSAGE: 213,   //禁言开始消息                x
  EM_MSG_TYPE_221_ANCHOR_PREMIERE_MESSAGE: 221,   //主播开播/停播消息
  EM_MSG_TYPE_222_BIG_RUNWAY_MESSAGE: 222,        //大跑道消息
  EM_MSG_TYPE_223_SMALL_RUNWAY_MESSAGE: 223,      //小跑道消息
  EM_MSG_TYPE_232_VIDEO_ADDR_CHANGE: 232,         //主播重新开播
  EM_MSG_TYPE_234_PK_Status_MESSAGE: 234,         //pk消息
  EM_MSG_TYPE_240_SMASH_EGG_MESSAGE: 240,         //砸蛋消息
  EM_MSG_TYPE_241_BUY_WARD_MESSAGE: 241,          //购买守护消息                 x
  EM_MSG_TYPE_243_LUCKY_GIFTS_AWARD_MESSAGE:243,  //幸运礼物获奖消息
  EM_MSG_TYPE_244_WARCRAFT_GAME_MESSAGE:244,      //打飞机游戏消息               x
  EM_MSG_TYPE_251_INFORM_FLOW_MESSAGE:251         //通知主播上报推流插件信息
};
// window.gOb_msgType = gOb_msgType;
export default{v_mifeng_trim,funcToJSONString,funcFilterSpace,gOb_msgType}



// WEBPACK FOOTER //
// ./src/utils/utils.js